<template>
	<div>
    	<div class="p-0" v-if="loading">
    		<preloader></preloader>
    	</div>
		<button class="btn btn-success btn-sm my-3" v-on:click="createEndoso" v-if="roleUser() != 'V' && !disabledValue">
			<i class="material-icons">add</i>
		</button>
		<button class="btn btn-primary btn-sm my-3" v-on:click="getEndosos">
			<i class="material-icons">refresh</i>
		</button>

		<div class="table-responsive" v-if="endosos.length>0">
			<table v-bind:class="{'table table-borderless table-hover table-striped':true, 'table-sm':compacta}">
	            <thead>
	                <tr class="border-bottom">
	                    <th class="d-none d-sm-none d-md-none d-lg-table-cell">No. Endoso</th>
	                    <th class="d-none d-sm-none d-md-none d-lg-table-cell">Fecha Inicial</th>
	                    <th class="d-none d-sm-none d-md-none d-lg-table-cell">Fecha Final</th>
	                    <th>Tipo Endoso</th>
	                    <th class="d-none d-sm-none d-md-none d-lg-table-cell">Prima Neta</th>
	                    <th class="d-none d-sm-none d-md-none d-lg-table-cell">Prima Total</th>
	                    <th width="150px">
	                    	<div class="custom-control custom-switch">
								<input type="checkbox" class="custom-control-input" id="compactaEndosos" v-model="compacta">
								<label class="custom-control-label" for="compactaEndosos">Compacta</label>
							</div>
	                    </th>
	                </tr>
	                <tr>
						<td colspan="7" class="p-1">
							<div class="text-muted text-uppercase font-weight-bolder text-monospace text-left">
								Endosos ({{endosos.length}})
							</div>
						</td>
					</tr>
	            </thead>
	            <tbody>
	            	<tr v-for="endoso in endosos" v-on:click="showEndoso(endoso)" class="cursor-pointer">
	                    <th class="d-none d-sm-none d-md-none d-lg-table-cell">{{endoso.NUMERO_ENDOSO}}</th>
	                    <td class="text-center d-none d-sm-none d-md-none d-lg-table-cell">{{endoso.FECHA_VIGENCIA_INI}}</td>
	                    <td class="text-center d-none d-sm-none d-md-none d-lg-table-cell">{{endoso.FECHA_VIGENCIA_FIN}}</td>
	                    <td class="text-center">{{endoso.tipo_endoso ? endoso.tipo_endoso.DESCRIPCION : 'No definido'}}</td>
	                    <td class="text-right d-none d-sm-none d-md-none d-lg-table-cell">{{money(endoso.PRIMA_NETA, 2)}}</td>
	                    <td class="text-right d-none d-sm-none d-md-none d-lg-table-cell">{{money(endoso.PRIMA_TOTAL, 2)}}</td>
	                    <td class="text-right" width="180px">
	                        <div class="table-hover-options">
		                        <a 
		                        	href="#" 
		                        	class="text-muted ml-2 p-1" 
		                        	v-tooltip="'Renovar endoso'" 
		                        	v-on:click.prevent.stop="renovarEndoso(endoso)"
		                        	v-if="roleUser() != 'V' && !disabledValue">
		                            <i class="material-icons">sync</i>
		                        </a>
		                        <a 
		                        	href="#" 
		                        	class="text-muted ml-2 p-1" 
		                        	v-tooltip="'Editar endoso'" 
		                        	v-on:click.prevent.stop="editEndoso(endoso)"
		                        	v-if="roleUser() != 'V' && !disabledValue">
		                            <i class="material-icons">edit</i>
		                        </a>
		                        <a 
		                        	href="#" 
		                        	class="text-muted ml-2 p-1" 
		                        	v-tooltip="'Eliminar endoso'" 
		                        	v-on:click.prevent.stop="deleteEndoso(endoso.CODIGO_ENDOSO)"
		                        	v-if="roleUser() != 'V' && !disabledValue">
		                            <i class="material-icons">delete</i>
		                        </a>
	                        </div>
	                    </td>
	                </tr>
	            </tbody>
	        </table>
	    </div>
	    <div v-else>
	    	<empty icon="speaker_notes_off" title="No hay Endosos." description="No hay endosos relacionados a esta póliza.">
            </empty>
	    </div>

    	<div class="modal fade" id="modalEndosos" role="dialog" aria-labelledby="modal-oportunidadLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
			    <div class="modal-content">
			      	<div class="modal-header">
			        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modal=='edit'">
			        		<i class="material-icons">edit</i>
			        		Editar endoso
			        	</h5>
			        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modal=='create'">
			        		<i class="material-icons">add</i>
			        		Registrar endoso
			        	</h5>
			        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modal=='show'">
			        		<i class="material-icons">search</i>
			        		Ver endoso
			        	</h5>
			        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modal=='renovar'">
			        		<i class="material-icons">sync</i>
			        		Renovar endoso
			        	</h5>
			    	</div>
			    	<preloader v-if="loadingForm"></preloader>
			    	<div class="modal-body p-0">
			    		<ul class="nav nav-tabs" id="myTabPolizasBienes" role="tablist">
						 	<li class="nav-item">
						    	<a class="nav-link active" id="polizasDetallesEndosos-tab" data-toggle="tab" href="#polizasDetallesEndosos" role="tab" aria-controls="polizasDetallesEndosos" aria-selected="true">Detalles</a>
						  	</li>

						  	<li class="nav-item">
						    	<a class="nav-link" id="polizasBienesEndosos-tab" data-toggle="tab" href="#polizasBienesEndosos" role="tab" aria-controls="polizasBienesEndosos" aria-selected="true">Bienes asegurados</a>
						  	</li>
						</ul>

						<div class="tab-content" id="myTabPolizasBienesEndososContent">
							<div class="tab-pane fade show active p-3" id="polizasDetallesEndosos" role="tabpanel" aria-labelledby="polizasDetallesEndosos-tab">
								<div class="form-row">
			    					<div class="col-md-9">
			    						<div class="form-row">
			    							<div class="col-md-2 mb-3">
							    				<label for="numero">Número Endoso:</label>
							    				<input
							    					id="numero"
							    					class="form-control form-control-sm"
							    					:disabled="form.disabled"
							    					v-model="form.numero">
							    				<div v-if="errors && errors.numero_endoso" class="text-white">
							                        {{ errors.numero_endoso[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-3 mb-3">
							    				<label for="tipoEndoso">Tipo de Endoso:</label>
							    				<catalogo-tipos-endosos 
							    					id="tipoEndoso"
							    					v-model="form.tipoEndoso" 
							    					:disabled="form.disabled || modal=='renovar'"></catalogo-tipos-endosos>
							    				<div v-if="errors && errors.tipo_endoso" class="text-white">
							                        {{ errors.tipo_endoso[0] }}
							                    </div>
							    			</div>
							    			
			    							<div class="col-md-3 mb-3">
							    				<label for="aseguradora">Aseguradora:</label>
							    				<catalogo-aseguradoras 
							    					:disabled="form.disabled || modal=='renovar'"
							    					v-model="form.aseguradora">
							    				</catalogo-aseguradoras>
									            <div v-if="errors && errors.aseguradora" 
									            	class="text-danger">
							                        {{ errors.aseguradora[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-4 mb-3">
							    				<label for="vendedor">Vendedor:</label>
							    				<catalogo-vendedores
							    					:disabled="form.disabled"
							    					v-model="form.vendedor">
							    				</catalogo-vendedores>
									            <div v-if="errors && errors.vendedor" 
									            	class="text-danger">
							                        {{ errors.vendedor[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-6 mb-3">
							    				<label for="cliente">Cliente:</label>
							    				<catalogo-clientes 
							    					:disabled="disabled"
							    					v-model="form.cliente">
							    				</catalogo-clientes>
									            <div v-if="errors && errors.cliente" 
									            	class="text-danger">
							                        {{ errors.cliente[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-6 mb-3">
							    				<label for="producto">Producto:</label>
							    				<catalogo-productos 
							    					id="producto"
							    					:disabled="form.disabled"
							    					v-model="form.producto">
							    				</catalogo-productos>
									            <div v-if="errors && errors.productos" 
									            	class="text-danger">
							                        {{ errors.productos[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-6 mb-3">
							    				<label for="formaPago">Canal de Pago:</label>
							    				<catalogo-formas-pagos 
							    					id="formaPago"
							    					:disabled="form.disabled"
							    					v-model="form.formaPago">
							    				</catalogo-formas-pagos>
									            <div v-if="errors && errors.forma_pago" class="text-danger">
							                        {{ errors.forma_pago[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-3 mb-3">
							    				<label for="vigencia_ini">Fecha Vigencia Inicial:</label>
							    				<date-picker 
							    					id="vigencia_ini"
							    					:disabled="form.disabled"
							    					class="form-control-sm"
							    					v-model="form.vigenciaIni"></date-picker>
									            <div v-if="errors && errors.vigencia_ini" 
									            	class="text-danger">
							                        {{ errors.vigencia_ini[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-3 mb-3">
							    				<label for="vigencia_fin">Fecha Vigencia Final:</label>
							    				<date-picker 
							    					id="vigencia_fin"
							    					:disabled="form.disabled"
							    					class="form-control-sm"
							    					v-model="form.vigenciaFin"></date-picker>
									            <div v-if="errors && errors.vigencia_fin" 
									            	class="text-danger">
							                        {{ errors.vigencia_fin[0] }}
							                    </div>
							    			</div>

							    			<div class="col-md-12 mb-3">
							    				<label for="observaciones">Observaciones:</label>
							    				<textarea 
							    					id="observaciones"
							    					:disabled="form.disabled"
							    					v-model="form.observaciones"
							    					class="form-control"
							    					maxlength="250">
							    				</textarea>
									            <div v-if="errors && errors.observaciones" 
									            	class="text-danger">
							                        {{ errors.observaciones[0] }}
							                    </div>
							    			</div>
							    		</div>
			    					</div>

			    					<div class="col-md-3 border-left">
			    						<div class="form-row">
			    							<div class="col-md-12 mb-3">
					    						<label for="sumaAsegurada">Suma Asegurada:</label>
					    						<decimal
					    							id="sumaAsegurada"
					    							:disabled="form.disabled"
					    							class="form-control-sm"
					    							v-model="form.sumaAsegurada"
					    							min="0"></decimal>
					    						<div v-if="errors && errors.suma_asegurada" 
									            	class="text-danger">
							                        {{ errors.suma_asegurada[0] }}
							                    </div>
					    					</div>
			    							
					    					<div class="col-md-6 mb-3">
					    						<label for="deducible1">Deducible 1:</label>
					    						<decimal
					    							id="deducible1"
					    							v-model="form.deducible1"
					    							class="form-control-sm"
					    							:disabled="form.disabled"
					    							min="0"></decimal>
					    						<div v-if="errors && errors.deducible1" 
									            	class="text-danger">
							                        {{ errors.deducible1[0] }}
							                    </div>
					    					</div>

					    					<div class="col-md-6 mb-2">
					    						<label for="deducible2">Deducible 2:</label>
					    						<decimal
					    							id="deducible2"
					    							v-model="form.deducible2"
					    							class="form-control-sm"
					    							:disabled="form.disabled"
					    							min="0"></decimal>
					    						<div v-if="errors && errors.deducible2" 
									            	class="text-danger">
							                        {{ errors.deducible2[0] }}
							                    </div>
					    					</div>

					    					<div class="col-md-12 mb-3">
					    						<label for="premaNeta">Prima Neta:</label>
					    						<decimal
					    							id="premaNeta"
					    							v-model="form.primaNeta"
					    							class="form-control-sm"
					    							:disabled="form.disabled"
					    							min="0"></decimal>
					    						<div v-if="errors && errors.prima_neta" 
									            	class="text-danger">
							                        {{ errors.prima_neta[0] }}
							                    </div>
					    					</div>

					    					<div class="col-md-12 mb-3">
					    						<label for="primaTotal">Prima Total:</label>
					    						<decimal
					    							id="primaTotal"
					    							v-model="form.primaTotal"
					    							class="form-control-sm"
					    							:disabled="form.disabled"
					    							min="0"></decimal>
					    						<div v-if="errors && errors.prima_total" 
									            	class="text-danger">
							                        {{ errors.prima_total[0] }}
							                    </div>
					    					</div>
					    					
					    					<div class="col-md-6 mb-3 w-100" v-if="!form.disabled && modal != 'create'">
				    							<label>Saldo:</label>
				    							<copy class="btn bg-secondary text-left text-white btn-block box-shadow" :text="money(saldo)">
				    								{{money(saldo, true)}}
						    					</copy>
					    					</div>
					    					
					    					<div class="col-md-6 mb-3" v-if="!form.disabled && modal != 'create'">
				    							<label>Total Cobrado:</label>
				    							<copy class="btn bg-dark text-left text-white btn-block box-shadow" :text="money(form.totalCobrado)">
						    						{{money(form.totalCobrado, true)}}
						    					</copy>
					    					</div>
			    						</div>
			    					</div>
					    		</div>
					    	</div>
							<div class="tab-pane fade p-3" id="polizasBienesEndosos" role="tabpanel" aria-labelledby="polizasBienesEndosos-tab">
								<div class="form-row">
					    			<div class="col-md-12 mb-2">
					    				<button class="btn btn-secondary btn-sm" type="button" v-on:click.prevent="addBien" v-if="(roleUser() != 'V' || modal!='show') && !disabledValue">
											<i class="material-icons">add_circle</i>
											Agregar
										</button>
				    					
				    					<div v-if="errors && errors['bien_asegurado']" class="text-danger">
											{{errors['bien_asegurado'][0]}}
										</div>

										<table class="table table-borderless table-sm table-hover" v-if="bienes.length>0">
											<thead>
												<tr>
													<th class="text-center">Bien Asegurado</th>
													<th width="120px" class="text-center">Suma Asegurada</th>
													<th width="120px" class="text-center">Deducible 1</th>
													<th width="120px" class="text-center">Deducible 2</th>
													<th width="120px" class="text-center">Prima Neta</th>
													<th width="120px" class="text-center">Prima Total</th>
													<th class="text-center">Observaciones</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item, index) in bienes" :class="{'table-danger':errors && errors['bien_asegurado.'+index]}">
													<td>
														<input type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.DESCRIPCION_BIEN">
														<div v-if="errors && errors['bien_asegurado.'+index+'.DESCRIPCION_BIEN']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.DESCRIPCION_BIEN'][0]}}
														</div>
													</td>
													<td>
														<decimal type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.SUMA_ASEGURADA" min="0"></decimal>
														<div v-if="errors && errors['bien_asegurado.'+index+'.SUMA_ASEGURADA']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.SUMA_ASEGURADA'][0]}}
														</div>
													</td>
													<td>
														<decimal type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.DEDUCIBLE1" min="0"></decimal>
														<div v-if="errors && errors['bien_asegurado.'+index+'.DEDUCIBLE1']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.DEDUCIBLE1'][0]}}
														</div>
													</td>
													<td>
														<decimal type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.DEDUCIBLE2" min="0"></decimal>
														<div v-if="errors && errors['bien_asegurado.'+index+'.DEDUCIBLE2']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.DEDUCIBLE2'][0]}}
														</div>
													</td>
													<td>
														<decimal type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.PRIMA_NETA" min="0"></decimal>
														<div v-if="errors && errors['bien_asegurado.'+index+'.PRIMA_NETA']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.PRIMA_NETA'][0]}}
														</div>
													</td>
													<td>
														<decimal type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.PRIMA_TOTAL" min="0"></decimal>
														<div v-if="errors && errors['bien_asegurado.'+index+'.PRIMA_TOTAL']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.PRIMA_TOTAL'][0]}}
														</div>
													</td>
													<td>
														<textarea type="text" name="bien_asegurado[]" class="form-control form-control-sm" v-model="item.OBSERVACIONES" maxlength="250"></textarea>
														<div v-if="errors && errors['bien_asegurado.'+index+'.OBSERVACIONES']" class="text-danger">
															{{errors['bien_asegurado.'+index+'.OBSERVACIONES'][0]}}
														</div>
													</td>
													<td width="50px">
														<div class="table-hover-options">
															<button type="button" v-on:click="deleteBien(index)" class="btn btn-sm btn-link text-muted" v-if="(roleUser() != 'V' || modal!='show') && !disabledValue">
															<i class="material-icons">delete</i>
															</button>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
										<div v-else class="text-center text-muted py-3">
											No se ha agregado ningún Bien Asegurado.
										</div>
					    			</div>
	    						</div>
							</div>
						</div>
			    	</div>
			    	<div class="modal-footer">
			    		<button 
			    			type="button" 
			    			class="btn btn-secondary" 
			    			:disabled="loadingForm"
			    			v-on:click.prevent="closeModalEndoso">
			    			Cancelar
			    		</button>

			    		<button 
			    			type="button" 
			    			class="btn btn-secondary"
			    			:disabled="loadingForm || loading" 
			    			v-if="modal=='edit' && roleUser() != 'V' && !disabledValue"
			    			v-on:click.prevent="updateEndoso">
			    			Actualizar
			    		</button>

			    		<button 
			    			type="button" 
			    			class="btn btn-secondary"
			    			:disabled="loadingForm || loading" 
			    			v-if="modal=='create'  && roleUser() != 'V'  && !disabledValue"
			    			v-on:click.prevent="storeEndoso">
			    			Crear
			    		</button>

			    		<button 
			    			type="button" 
			    			class="btn btn-link"
			    			:disabled="loadingForm || loading" 
			    			v-if="modal=='show' && roleUser() != 'V' && !disabledValue"
			    			v-on:click.prevent="editEndoso(form)">
			    			Editar
			    		</button>

			    		<button 
			    			type="button" 
			    			class="btn btn-link" 
			    			:disabled="loadingForm || loading" 
			    			v-if="modal=='renovar' && roleUser() != 'V' && !disabledValue"
			    			v-on:click.prevent="renovarEndosoStore(form)">
			    			Renovar
			    		</button>
			    	</div>
			    </div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['poliza', 'disabledVal'],

		mounted(){
			this.codigo = this.poliza;
			if (this.codigo) {
        		this.getEndosos();
			}

			var vm = this;
			$.fn.getEndosos = function () {
				vm.getEndosos();
			};
		},

		data(){
			return {
				endosos: [],
				codigo: '',
				loading: false,
				loadingForm: false,
				modal: 'create',
				firstWatch: true,

				disabled: false,
				form: {
					disabled: false,

					poliza: '',
					numero: '',
					vigenciaIni: '',
					vigenciaFin: '',
					tipoEndoso: '',
					primaNeta: 0,
					primaTotal: 0,

					cliente: '',
					vendedor: '',
					aseguradora: '',
					producto: '',
					
					formaPago: '',
					sumaAsegurada: 0,
					deducible1: 0,
					deducible2: 0,
					totalCobrado: 0,
					observaciones: '',
					cobrosProgramados: 0,
				},

				bienes: [],
				compacta: false,
				errors: {},
			}
		},

		methods: {
			addBien: function(){
				this.bienes.push({
					CODIGO_BIEN: 0,
					CODIGO_ENDOSO: 0,
					CODIGO_POLIZA: 0,

					DESCRIPCION_BIEN: '',
					SUMA_ASEGURADA: 0,
					DEDUCIBLE1: 0,
					DEDUCIBLE2: 0,
					PRIMA_NETA: 0,
					PRIMA_TOTAL: 0,
					OBSERVACIONES: ''
				})
			},

			deleteBien: function(index){
				this.bienes.splice(index, 1)
				this.errors = {}
			},

			getBienes: function(endoso){
				this.loading = true
				axios.get('api/endosos/'+endoso+'/bienes')
				.then(response=>{
					this.bienes = response.data
				}).catch(error=>{
					console.log(error.response)
				}).then(() => {
					this.loading = false
				})
			},

			getEndosos: function(){
				this.loading = true;
				var url = 'api/polizas/'+this.codigo+'/endosos';

				axios.get(url)
				.then(response => {
					this.endosos = response.data;
					$('#badge-endosos').text(response.data.length);
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			storeEndoso:function(){
				var url = '/api/polizas/'+this.codigo+'/endosos';
				this.errors = {};
	            this.loadingForm = true;

	            axios.post(url, {
					numero_endoso: this.form.numero,
					vigencia_ini: this.form.vigenciaIni,
					vigencia_fin: this.form.vigenciaFin,
					tipo_endoso: this.form.tipoEndoso,
					prima_neta: this.form.primaNeta,
					prima_total: this.form.primaTotal,

					vendedor: this.form.vendedor,
					aseguradora: this.form.aseguradora,
					bien_asegurado: this.bienes,
					forma_pago: this.form.formaPago,
					suma_asegurada: this.form.sumaAsegurada,
					deducible1: this.form.deducible1,
					deducible2: this.form.deducible2,
					observaciones: this.form.observaciones,
	            }).then(response => {
	                this.getEndosos();
					this.closeModalEndoso();
					this.$toasted.show('El Endoso ha sido registrado.');
					$('html').getCobrosProgramados();
					$('html').getCobrosRealizados();
					$('html').getPolizasLog();
					$('html').getDetallePoliza();
					$('html').getBienesDetalle();
	            }).catch(error => {
	                console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al registrar Endoso.');
	            }).then(() => {
	            	this.loadingForm = false;
	            });
			},

			updateEndoso: function(){
				var url = '/api/polizas/endosos/'+this.form.codigo;
	            this.loadingForm = true;
	            this.errors = {};

	            axios.put(url, {
	            	//codigo: this.form.poliza,
					numero_endoso: this.form.numero,
					vigencia_ini: this.form.vigenciaIni,
					vigencia_fin: this.form.vigenciaFin,
					tipo_endoso: this.form.tipoEndoso,
					prima_neta: this.form.primaNeta,
					prima_total: this.form.primaTotal,
					cliente:this.form.cliente,
					vendedor: this.form.vendedor,
					aseguradora: this.form.aseguradora,
					producto: this.form.producto,
					bien_asegurado: this.bienes,
					forma_pago: this.form.formaPago,
					suma_asegurada: this.form.sumaAsegurada,
					deducible1: this.form.deducible1,
					deducible2: this.form.deducible2,
					observaciones: this.form.observaciones,
	            }).then(response => {
	                this.getEndosos();
					this.closeModalEndoso();
					this.$toasted.show('El Endoso ha sido actualizado.');
					$('html').getPolizasLog();
					$('html').getDetallePoliza();
					$('html').getBienesDetalle();
	            }).catch(error => {
	                console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al actualizar Endoso.');
	            }).then(() => {
	            	this.loadingForm = false;
	            });
			},

			editEndoso: function(data){
				this.setData(data);
				this.modal = 'edit';
				this.form.disabled = false;
				this.disabled = false;
				this.getBienes(data.CODIGO_ENDOSO)
				this.errors = {}
				this.openModalEndoso();
			},

			renovarEndoso: function(data){
				this.setData(data);
				this.form.tipoEndoso = 'R'
				this.form.vigenciaIni = this.form.vigenciaFin
				this.form.vigenciaFin = moment(this.form.vigenciaFin, 'DD-MM-YYYY').add(1, 'years').format('DD-MM-YYYY')

				this.modal = 'renovar';
				this.form.disabled = false
				this.disabled = true
				this.getBienes(data.CODIGO_ENDOSO)
				this.errors = {}
				this.openModalEndoso()
			},

			renovarEndosoStore: function(){
				var url = '/api/polizas/endosos/'+this.form.codigo+'/renovar';
	            this.loadingForm = true;
	            this.errors = {};

	            axios.put(url, {
					numero_endoso: this.form.numero,
					vigencia_ini: this.form.vigenciaIni,
					vigencia_fin: this.form.vigenciaFin,
					tipo_endoso: this.form.tipoEndoso,
					prima_neta: this.form.primaNeta,
					prima_total: this.form.primaTotal,

					vendedor: this.form.vendedor,
					aseguradora: this.form.aseguradora,
					producto: this.form.producto,
					bien_asegurado: this.bienes,
					forma_pago: this.form.formaPago,
					suma_asegurada: this.form.sumaAsegurada,
					deducible1: this.form.deducible1,
					deducible2: this.form.deducible2,
					observaciones: this.form.observaciones,
	            }).then(response => {
	                this.getEndosos();
					this.closeModalEndoso();
					this.$toasted.show('El Endoso ha sido renovado.');
					$('html').getPolizasLog();
					$('html').getDetallePoliza();
					$('html').getBienesDetalle();
					$('html').getCobrosProgramados();
					$('html').getCobrosRealizados();
	            }).catch(error => {
	                console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al actualizar Endoso.');
	            }).then(() => {
	            	this.loadingForm = false;
	            });
			},

			deleteEndoso: function(id){
				var url = 'api/polizas/endosos/'+id;
                var modules = this
                $.confirm({
                    title: '¿Estás seguro?',
                    content: '¡Ya no podrás recuperar esta información!',
                    theme: 'supervan', // 'material', 'bootstrap'
                    buttons: {
                        Confirmar: function () {
                            axios.delete(url)
                                .then(response => {
                                	modules.getEndosos();
					
									$('html').getCobrosProgramados();
									$('html').getCobrosRealizados();
									$('html').getPolizasLog();
									$('html').getDetallePoliza();
									$('html').getBienesDetalle();
                                    modules.$toasted.show('Eliminado');
                                })
                                .catch(error => {
                                    modules.$toasted.show('Error al eliminar');
                                    console.log(error.response);
                                });
                        },
                        Cancelar: function () {
                        },
                    }
                });
			},

			showEndoso: function(data){
				this.setData(data);
				this.modal = 'show';
				this.form.disabled = true;
				this.disabled = true;
				this.getBienes(data.CODIGO_ENDOSO)
				this.errors = {}
				this.openModalEndoso();
			},

			createEndoso: function(){
				this.form.codigo = '';
				this.form.poliza = 0;
				this.form.numero = 0;
				this.form.vigenciaIni = '';
				this.form.vigenciaFin = '';
				this.form.tipoEndoso = '';
				this.form.primaNeta = 0;
				this.form.primaTotal = 0;

				this.form.cliente = '';
				this.form.vendedor = '';
				this.form.aseguradora = '';
				this.form.producto = '';
				
				this.form.formaPago = '';
				this.form.sumaAsegurada = 0;
				this.form.deducible1 = 0;
				this.form.deducible2 = 0;
				this.form.observaciones = '';
				this.form.totalCobrado = 0;
				this.form.cobrosProgramados = 0;

				this.modal = 'create';
				this.form.disabled = false;
				this.disabled = true;
				this.bienes = []
				this.errors = {}

				var url = 'api/oportunidades/polizas/'+this.codigo;
				axios.get(url)
				.then(response => {
					this.form.cliente = response.data.CODIGO_CLIENTE
					this.form.vendedor = response.data.CODIGO_VENDEDOR
					this.form.aseguradora = response.data.CODIGO_ASEGURADORA
					this.form.producto = response.data.producto ? response.data.producto.CODIGO_PRODUCTO : ''
					this.form.vigenciaIni = response.data.FECHA_VIGENCIA_FIN
					this.form.vigenciaFin = moment(response.data.FECHA_VIGENCIA_FIN, "DD-MM-YYYY").add(1, 'y').format("DD-MM-YYYY")
				});
				this.openModalEndoso()
			},

			openModalEndoso: function(){
				$('#modalEndosos').modal('show')
				$('#myTabPolizasBienes a[href="#polizasDetallesEndosos"]').tab('show')
			},

			closeModalEndoso: function(){
				$('#modalEndosos').modal('hide')
			},

			setData: function(data){
				this.form.codigo = data.CODIGO_ENDOSO;
				this.form.poliza = data.CODIGO_POLIZA;
				this.form.numero = data.NUMERO_ENDOSO;
				this.form.vigenciaIni = data.FECHA_VIGENCIA_INI;
				this.form.vigenciaFin = data.FECHA_VIGENCIA_FIN;
				this.form.tipoEndoso = data.TIPO_ENDOSO;
				this.form.primaNeta = data.PRIMA_NETA;
				this.form.primaTotal = data.PRIMA_TOTAL;

				this.form.cliente = data.CODIGO_CLIENTE;
				this.form.vendedor = data.CODIGO_VENDEDOR;
				this.form.aseguradora = data.CODIGO_ASEGURADORA;
				this.form.producto = data.CODIGO_PRODUCTO;
				
				this.form.formaPago = data.CODIGO_FORMA_PAGO;
				this.form.sumaAsegurada = data.SUMA_ASEGURADA;
				this.form.deducible1 = data.DEDUCIBLE1;
				this.form.deducible2 = data.DEDUCIBLE2;
				this.form.observaciones = data.OBSERVACIONES;
				this.form.totalCobrado = data.TOTAL_COBRADO;
				this.form.cobrosProgramados = data.cobros_programados ? data.cobros_programados.TOTAL : 0;
			}
		},

		computed: {
			saldo: function(){
            	return this.form.cobrosProgramados - this.form.totalCobrado;
            },

            disabledValue: function(){
            	return this.disabledVal
            }
        },

        watch: {
        	poliza: function(val){
        		if (val) {
        			this.codigo = val;
        			this.getEndosos();
        		}
        	},

			bienes: {
				handler: function(val, oldVal){
					if (this.firstWatch) {
						this.firstWatch = false
						return;
					}

					if (val.length > 0) {
						let suma = [];
						let deducible1 = [];
						let deducible2 = [];
						let neta = [];
						let total = [];

						Object.entries(val).forEach(([key, val]) => {
							suma.push(val.SUMA_ASEGURADA)
							deducible1.push(val.DEDUCIBLE1)
							deducible2.push(val.DEDUCIBLE2)
							neta.push(val.PRIMA_NETA)
							total.push(val.PRIMA_TOTAL)
						});

						var tsuma = suma.reduce(function(total, num){ return parseFloat(total || 0) + parseFloat(num || 0) }, 0);
						var tdeducible1 = deducible1.reduce(function(total, num){ return parseFloat(total || 0) + parseFloat(num || 0) }, 0);
						var tdeducible2 = deducible2.reduce(function(total, num){ return parseFloat(total || 0) + parseFloat(num || 0) }, 0);
						var tneta = neta.reduce(function(total, num){ return parseFloat(total || 0) + parseFloat(num || 0) }, 0);
						var ttotal = total.reduce(function(total, num){ return parseFloat(total || 0) + parseFloat(num || 0) }, 0);
						
						this.form.sumaAsegurada = tsuma
						this.form.deducible1 = tdeducible1
						this.form.deducible2 = tdeducible2
						this.form.primaNeta = tneta
						this.form.primaTotal = ttotal
					}

				},
				deep:true
			}
  		}
	}
</script>